import type { FC, PropsWithChildren } from 'react';
import { useMemo } from 'react';

import { useMedia } from '@opendoor/bricks-next';
import { AddContextualData } from '@opendoor/observability/slim';

function getDeviceSize(
  smallerThanMD: boolean,
  smallerThanLG: boolean,
): 'desktop' | 'tablet' | 'mobile' {
  if (smallerThanMD) {
    return 'mobile';
  }
  if (smallerThanLG) {
    return 'tablet';
  }
  return 'desktop';
}

/**
 * Attaches the current device size category to observability contextual data
 * so it is included as an attribute on analytics events.
 */
export const DeviceSizeContextualData: FC<PropsWithChildren> = ({ children }) => {
  const { smallerThanMD, smallerThanLG } = useMedia();
  const contextualData = useMemo(
    () => ({ deviceSize: getDeviceSize(smallerThanMD, smallerThanLG) }),
    [smallerThanLG, smallerThanMD],
  );
  return <AddContextualData data={contextualData}>{children}</AddContextualData>;
};
